module.exports = __webpack_public_path__ + "static/media/arrowUp.5009dba4.svg";